import { CreditCard, ListChecks } from "lucide-react";
import {
  OUTBOUND_CAMPAIGN_PRICING,
  VOICE_ENGINE_OPTIONS,
  formatCostRate,
  formatCustomerRate,
  formatMinuteRate
} from "../../lib/voice-pricing";

export interface BillingPanelProps {}

export function BillingPanel(_: BillingPanelProps) {
  return (
    <section className="billing-grid" aria-label="Usage billing">
      <article className="panel billing-rate-card">
        <div className="panel-header">
          <div>
            <h2>Voice engine rate card</h2>
            <p>Suggested customer rates by default engine and call type.</p>
          </div>
          <span>Per minute</span>
        </div>
        <div className="table-wrap compact-table">
          <table>
            <thead>
              <tr>
                <th>Tier</th>
                <th>Reasoning</th>
                <th>Est. AI cost/min</th>
                <th>Inbound cost</th>
                <th>Suggested inbound price</th>
                <th>AU local outbound cost</th>
                <th>Suggested local outbound</th>
                <th>AU mobile outbound cost</th>
                <th>Suggested mobile outbound</th>
              </tr>
            </thead>
            <tbody>
              {VOICE_ENGINE_OPTIONS.map((engine) => (
                <tr key={engine.id}>
                  <td>{engine.tier}</td>
                  <td>{engine.reasoning}</td>
                  <td>{formatCostRate(engine.estimatedAiCostPerMinute)}</td>
                  <td>{formatCostRate(engine.inboundCost)}</td>
                  <td>{formatCustomerRate(engine.suggestedInboundPrice)}</td>
                  <td>{formatCostRate(engine.auLocalOutboundCost)}</td>
                  <td>{formatCustomerRate(engine.suggestedLocalOutboundPrice)}</td>
                  <td>{formatCostRate(engine.auMobileOutboundCost)}</td>
                  <td>{formatCustomerRate(engine.suggestedMobileOutboundPrice)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </article>

      <article className="panel">
        <div className="card-heading">
          <CreditCard size={21} />
          <div>
            <h2>Inbound toll-free</h2>
            <p>Add about $0.04/min cost over local/mobile inbound. Suggested customer price is +$0.05/min over the inbound table.</p>
          </div>
        </div>
      </article>

      <article className="panel">
        <div className="card-heading">
          <ListChecks size={21} />
          <div>
            <h2>Outbound campaigns</h2>
            <p>Connected outbound minutes use the outbound rate table. Reserved campaign capacity is charged separately.</p>
          </div>
        </div>
        <div className="resource-list">
          <div>
            <span>Reserved concurrency</span>
            <strong>{formatMinuteRate(OUTBOUND_CAMPAIGN_PRICING.reservedConcurrencyRate)} / line / reserved min</strong>
          </div>
          <div>
            <span>Minimum reservation</span>
            <strong>{OUTBOUND_CAMPAIGN_PRICING.minimumReservationMinutes} minutes</strong>
          </div>
          <div>
            <span>Transfer to PSTN</span>
            <strong>Add second outbound leg</strong>
          </div>
        </div>
      </article>
    </section>
  );
}
